import { Component } from 'react';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';

const utmRegex = /utm_medium|utm_campaign|utm_source/gi;

class Campaign extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    cookies: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.setCampaign();
  }

  setCampaign() {
    if (typeof document !== 'undefined') {
      const { URL: url, referrer } = document;

      if (referrer || (url && url.match(utmRegex))) {
        this.props.cookies.set('campaign', JSON.stringify({ url, referrer }), {
          path: '/',
        });
      }
    }
  }

  render() {
    return this.props.children;
  }
}

export default withCookies(Campaign);



// WEBPACK FOOTER //
// ./src/campaign/CookieCampaign.js